import { render, staticRenderFns } from "./PhotoSection.vue?vue&type=template&id=3f1f14fe"
import script from "./PhotoSection.vue?vue&type=script&lang=ts"
export * from "./PhotoSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports